// CareLogix™ ORACLE — Signal Engine API client (Phase 32A)
import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const SIGNAL_BASE = `${BASE}/api/oracle/signals`;

const http = axios.create({ baseURL: SIGNAL_BASE, timeout: 25_000 });

export const signalApi = {
  catalog: () => http.get("/catalog"),
  scan:    (universe, limit) =>
    http.get("/scan", { params: { universe: universe || "stocks", limit: limit || 12 } }),
  top:     (limitPerUniverse) =>
    http.get("/top", { params: { limit_per_universe: limitPerUniverse || 3 } }),
  signal:  (symbol, universe) =>
    http.get("/signal", { params: { symbol, universe: universe || "stocks" } }),
};

export default signalApi;
